import riaApiClient from "@/api";
import store from '@/store/index.js'

const version = process.env.VUE_APP_API_VERSION;

export default {
  namespaced: true,
  state: {
    _product: {},
    _extras: {},
    _keycard: {},
    _promoCode: {}
  },
  getters: {
    product: state => state._product,
    originalPrice: state => (date, participantId) => {
      return parseFloat(date ? 
        state._product[date][participantId].original_amount : 
        state._product['best_prices'][participantId].original_amount);
    },
    productPrice: state => (date, participantId) => {
      return parseFloat(date ? 
        state._product[date][participantId].best_amount : 
        state._product['best_prices'][participantId].best_amount);
    },
    keycardPrice: state => (date, participantId) => {
      return parseFloat(date
        ?state._keycard[date][participantId].best_amount
        :state._keycard['best_prices'][participantId].best_amount);
    },
    promoPrice(state, getters){
      if (!getters.promoActive) return 0

      if (!state._promoCode.product && !state._promoCode.participant) {
        if(state._promoCode.type === "percent")
          return parseFloat(state._promoCode.amount) / 100 * store.getters['order/totalPrice']
        else if(state._promoCode.type === "amount")
          return Math.min(parseFloat(state._promoCode.amount), store.getters['order/totalPrice'])
      }

      return store.getters['order/details'].reduce((carry, detail) => {
        if (
          (state._promoCode.product && state._promoCode.participant && detail.product_id == state._promoCode.product.id && detail.participant_id == state._promoCode.participant.id) ||
          (!state._promoCode.product && state._promoCode.participant && detail.participant_id == state._promoCode.participant.id) ||
          (state._promoCode.product && !state._promoCode.participant && detail.product_id == state._promoCode.product.id)
        ) {
          let productPrice = store.getters['prices/productPrice'](detail.date, detail.participant_id)
          let discountPrice = 0;
          if(state._promoCode.type === "percent")
            discountPrice = parseFloat(state._promoCode.amount) / 100 * productPrice
          else if(state._promoCode.type === "amount")
            discountPrice = Math.min(parseFloat(state._promoCode.amount), productPrice)

          return discountPrice + carry
        }
        return carry;
      }, 0)
    },
    extras: state => state._extras,
    loadedExtras: state => Object.keys(state._extras).length !== 0,
    hasExtra: state => (extraId, participantId) => typeof state._extras[extraId] !== 'undefined' && typeof state._extras[extraId][participantId] !== 'undefined',
    extraPrice: state => (extraId, participantId) => parseFloat(state._extras[extraId][participantId].best_amount),
    keycard: state => state._keycard,
    promoCode: state => state._promoCode,
    promoActive: state => {
      return Object.keys(state._promoCode).length > 0 && !state._promoCode.error && state._promoCode.active && state._promoCode.quantity > 0
    }
  },
  actions: {
    async loadProductPrices(context, payload) {
      try {
        const response = await riaApiClient.get(`/api/${version}/products/${payload.productid}/prices_map`)
        context.commit("SET_PRODUCT", response.data);
      } catch (error) {
        console.error("Error on reading product prices map", error)
      }
    },
    async loadExtrasPrices(context, payload) {
      for (const extra of payload.extras) {
        try {
          const response = await riaApiClient
            .get(`/api/${version}/products/${extra}/prices_map`)
          
          context.commit("ADD_EXTRA", {
            id: extra, 
            data: payload.date ? response.data[payload.date] : response.data['best_prices']
          })
        } catch (error) {
          console.error("Error on reading extra prices map", error)
        }
      }
    },
    async loadKeycard(context, payload) {
      try {
        const keycard = await riaApiClient.get(`/api/${version}/products/${payload.keycardid}/prices_map`)
        context.commit("SET_KEYCARD", keycard.data);
      } catch (error) {
        console.error("Error on reading keycard prices map", error)
      }
    },
    async loadPromoCode(context, payload) {
      try {
        const promocode = await riaApiClient.post(`/api/${version}/resorts/${payload.resort_id}/validate_promocode`, payload)
        context.commit("SET_PROMOCODE", promocode.data)
      } catch (error) {
        context.commit("SET_PROMOCODE", {"error": error})
      }
    },
    resetPromoCode(context){
      context.rootGetters['order/order'].promotion_id = null
      context.commit("SET_PROMOCODE", {})
    }
  },
  mutations: {
    SET_PRODUCT(state, payload) {
      state._product = payload
    },
    ADD_EXTRA(state, payload) {
      state._extras = { ...state._extras, ...{ [payload.id]: payload.data } }
    },
    SET_KEYCARD(state, payload) {
      state._keycard = payload
    },
    SET_PROMOCODE(state, payload) {
      state._promoCode = payload
    }
  }
};
